export default __webpack_public_path__ + "static/media/verify.c6564e94.svg";